export default __webpack_public_path__ + "static/all-3b101169732ff9c7afd70dbdb714bcad.svg";